import pure from "../components/higher-order/pure";
import React from "react";
import TermsOfService from "../components/terms-of-service";

export default pure(function TermsAndConditionsPage() {
  return (
    <div className="l-main l-row">
      <div className="l-wrapper">
        <div className="l-content l-content--80-percent">
          <TermsOfService />
        </div>
      </div>
    </div>
  );
});
